import config from 'veui/managers/config'

config.defaults(
  {
    parts: {
      shortcuts: 'link',
      dayPicker: 'small',
      tooltip: 'small'
    }
  },
  'schedule'
)
